import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Box,
  styled,
  Typography as MuiTypography,
} from '@mui/material';

export const Accordion = styled(MuiAccordion)(
  ({ theme }) => `
  margin-bottom: 10px;
  border-bottom: 1px solid ${theme.palette.brand.disable};
`,
);

export const AccordionSummary = styled(MuiAccordionSummary)`
  padding-bottom: 10px;
`;

export const AccordionDetails = styled(MuiAccordionDetails)`
  display: flex;
  width: 90%;
  margin: auto;
  margin-bottom: 30px;
  justify-content: space-between;
  flex-direction: column;
`;

export const Section = styled(Box)`
  width: 100%;
`;

export const DisclaimerOpsContainer = styled(Box)`
  padding-left: 50px;
`;

export const DisclaimerContainer = styled(Box)`
  padding-top: 20px;
`;

export const Label = styled(MuiTypography)`
  font-weight: 400;
  margin-bottom: 8px;
`;

export const CodMessage = styled(MuiTypography)`
  font-weight: 400;
  margin-bottom: 8px;
  color: #255f7a;
  background-color: #e5f6fd;
  padding: 20px;
`;
